// extracted by mini-css-extract-plugin
export default {"cls1":"h0izNw7LhF6CZztAHrr5","cls2":"oxvczIV4FyfgQYS47K8H h0izNw7LhF6CZztAHrr5","loading":"sOkrfwAS0zAhKqYX3TOd"};